import React from 'react';
import uuid from 'uuid';
import User from '../../helper/currentUser';

export default class SessionInit extends React.Component {
  constructor(props) {
    super(props);

    const user = new User();
    const batchEvents = {};

    const userId = user.id() || 'NOT_LOGGED_IN';
    window.userSessionId = btoa(`${userId}_${uuid()}`);

    const amplitudeInstance = window.amplitude.getInstance();
    const logEvent = amplitudeInstance.logEvent;

    const defaultArgs = {
      userSessionId: window.userSessionId,
      cookie: document.cookie,
      appVersion: process.env.BITBUCKET_BUILD_NUMBER
    };

    function track(eventName, args = defaultArgs) {
      logEvent.apply(amplitudeInstance, [eventName, args]);
    }

    window.analytics = {
      track,
      trackBatch: (eventName, data, batchEventCount) => {
        if (!batchEvents[eventName]) {
          batchEvents[eventName] = [];
        }
        if (batchEvents[eventName].length >= batchEventCount) {
          const args = {
            ...defaultArgs,
            data: batchEvents[eventName]
          };
          track(eventName, args);
          clearTimeout(batchEvents[eventName].timerId);
          batchEvents[eventName] = [];
        } else {
          batchEvents[eventName].push(data);
          if (!batchEvents[eventName].timerId) {
            batchEvents[eventName].timerId = setTimeout(() => {
              const args = {
                ...defaultArgs,
                data: batchEvents[eventName]
              };
              track(eventName, args);
              batchEvents[eventName] = [];
              clearTimeout(batchEvents[eventName].timerId);
            }, 20000);
          }
        }
      }
    };
  }

  render() {
    return null;
  }
}
